import React from 'react'

type Props = {

}

export function VirementClassiquePane({}: Props) {
    return (
        <div>
            <p css={{fontWeight: 'bold', fontSize: '16px', marginBottom: '10px'}}>Virement classique</p>
            <p css={{fontSize: '14px'}}>Pour recevoir les coordonnées afin d’effectuer votre virement, veuillez nous envoyer le montant que vous souhaitez investir à l’adresse suivante : <strong>investisseurs@villyz.fr</strong>.</p>
        </div>
    )
}